/* eslint-disable no-dupe-keys */
/* eslint-disable camelcase */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable consistent-return */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import { motion } from 'framer-motion';
import moment from 'moment';
import React, { useState, useRef } from 'react';
import Modal from 'react-modal';
import { Link } from 'react-router-dom';
import ThreeDotsLoader from '../../../Components/LoadingDots';
import { GenerateDate, GenerateDateandTime } from '../../../redux/helper/DateConverter';
import { CamelCase, PriceHandler } from '../../../redux/helper/CamelCase';

export default function PendingApprovalList({
    DAPList,
    isLoaded,
}) {
    const customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
        },
    };
    const [searchValue, setsearchValue] = useState('');
    const wf_status = {
        0: 'ASE - Unassigned',
        1: 'ASE -  Assigned',
        3: 'RBM - Approval',
        2: 'RBM - Rejected',
        4: 'Distributor - Accepted',
        9: 'Distributor - Declined',
        5: 'BH - Approved',
        6: 'BH - Rejected',
        7: 'CSD - Approved',
        8: 'CSD - Rejected',
        10: 'ASM - Approved',
        11: 'ASM - Rejected',
        12: 'Costing Approved',
        13: 'Costing Rejected',
        14: 'Accountant Approved',
        15: 'Accountant Rejected',
        16: 'TH - Approved',
        17: 'TH - Rejected',
        18: 'TDC - Approved',
        19: 'TDC - Rejected',
        20: 'Plant Quality Approved',
        21: 'Plant Quality Rejected',
    };
    const ref = useRef();
    const SerachUser = (val) => {
        if (searchValue === '') {
            return val;
        }
        if (val.email.toLowerCase().includes(searchValue.toLowerCase())) {
            return val;
        }
    };
    const handleStatus = (status) => {
        let res = '';
        if (status === 'Active') {
            res = 'border-[#D7F8DC] bg-[#D7F8DC] pr-10';
        }
        if (status === 'Inactive' || status === '0') {
            res = 'border-[#808285] bg-[#808285] text-[#FFFFFF] pr-10';
        }
        if (status === 'Draft') {
            res = 'border-[#FFF2DE] bg-[#FFF2DE] text-[#555259] pr-10';
        }
        if (status === 'Expired') {
            res = 'border-[#F8E1E4] bg-[#F8E1E4] text-[#555259] pr-10';
        }
        return res;
    };
    const handleImage = (status) => {
        let res = '';
        if (status === 'Active') {
            res = 'Active-icon.svg';
        }
        if (status === 'Inactive' || status === '0') {
            res = 'inactive-1.svg';
        }
        if (status === 'Draft') {
            res = 'draft.svg';
        }
        if (status === 'Expired') {
            res = 'expired-1.svg';
        }
        return res;
    };
    const handleStaustext = (status) => {
        let res = '';
        if (status === 'Active') {
            res = 'Deactivate';
        }
        if (status === 'Inactive') {
            res = 'Active';
        }
        if (status === 'Draft') {
            res = 'Activate';
        }

        return res;
    };
    const handleStatusAction = (status) => {
        let isTrue = false;
        if (status === 'Draft') {
            isTrue = true;
        }
        if (status === 'Active') {
            isTrue = true;
        }
        return isTrue;
    };
    return (
        <tbody>

            {DAPList?.filter((val) => SerachUser(val)).map((user, i) => (

                <>
                    <motion.tr
                        className="text-sm font-normal text-[#090406] py-2.5 px-4 sticky left-0 bg-[#ffffffe6]"
                        key={isLoaded}
                        animate={{ opacity: 1, x: 0 }}
                        initial={{ opacity: 0, x: -10 }}
                        exit={{ opacity: 0, x: -10 }}
                        transition={{ duration: 0.15 }}
                    >
                        <td className="text-sm font-normal text-[#090406] py-2.5 px-4 sticky left-0 bg-[#ffffffe6]">
                            <p>
                                {' '}
                                {user?.order_initial_number}
                            </p>
                        </td>
                        <td className="text-sm font-normal text-[#090406] py-2.5 px-5 text-left">
                            {user?.distributor_id}
                        </td>
                        <td className="text-sm font-normal text-[#090406] text-left py-2.5 px-4">
                            {user?.distributor_company_name}
                        </td>
                        <td className="text-sm font-normal  text-[#090406] py-2.5 px-4 text-left">
                            {GenerateDateandTime(user?.created_at)}
                        </td>
                        <td className="text-sm font-normal text-[#090406] py-2.5 px-4 text-left">
                            {user?.po_number || '-'}
                        </td>
                        <td className="text-sm font-normal text-[#090406] py-2.5 px-4 text-left">
                            {user?.order_type}
                        </td>
                        <td className="text-sm font-normal text-[#090406] py-2.5 px-4 text-center">
                            {user?.total_items}
                        </td>
                        {' '}
                        <td className="text-sm font-normal text-[#090406] py-2.5 px-4 text-end">
                            {PriceHandler(user?.total_price)}
                        </td>
                        {' '}
                        <td className="text-sm font-normal text-[#090406] py-2.5 px-4 text-center">
                            {user?.distributor_type}
                        </td>
                        {' '}
                        <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                            {user?.initial_category === '' ? '-' : user?.initial_category}
                        </td>
                        {' '}
                        <td className="text-sm font-normal text-[#090406] py-2.5 px-4 text-left">
                            {wf_status[user?.work_flow_status]}
                        </td>
                        <td className="text-sm font-normal text-[#090406] py-2.5 text-center px- sticky right-0 bg-[#ffffffe6]" data-testid={`view-btn-${i}`}>
                            <Link to={`/manage-pending-approvals/${user.distributor_id}/${user.order_number}/view`}>
                                <button
                                    type="button"
                                    className="text-[#fff]"
                                    style={{
                                        background: '#44445E',
                                        padding: '5px 10px',
                                        borderRadius: '4px',
                                    }}
                                >
                                    View
                                </button>
                            </Link>
                        </td>
                    </motion.tr>
                    <tr className="h-1" />
                </>
            ))}
        </tbody>
    );
}
